import { useContext } from "react";
import { SearchBoxContext } from "../SearchBoxContext/index.js";
const useSubmit = () => {
    const { i18n, trackV2, doSearch, isHeaderUpdateExp } = useContext(SearchBoxContext);
    return { i18n, trackV2, doSearch, isHeaderUpdateExp };
};
export default useSubmit;
